const project = window.fe.project
export default {
  queryNotice: {
    type: 'post',
    url: `${project}/sysnotice/queryNotice`
  }
}
